<script>
	export let isActiveTile = false;
</script>

{#if isActiveTile}
<div id="activeTile">
    
</div>
{:else}
<div>
    
</div>
{/if}

<style>
    div {
        background-color: rgb(255, 255, 255);
        width:100%;
        border-left: solid 3px rgb(233, 233, 233);
        border-top: solid 1px rgb(201, 201, 201);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #activeTile {
        background-color: rgb(0, 0, 0);
    }
</style>